import { useEffect } from "react";

const RedirectToExternal = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null; // You can return a loading spinner or message if needed
};

export default RedirectToExternal;
